module.exports = __webpack_public_path__ + "img/notif.3be7fce9.svg";